import { render, staticRenderFns } from "./GoogleAdMarketing.vue?vue&type=template&id=1b268b61&"
import script from "./GoogleAdMarketing.vue?vue&type=script&lang=ts&"
export * from "./GoogleAdMarketing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports